import CheckBox from "./CheckBox";

const BaseLines = ({ data, setData }) => {
    return (
        <div className="base-lines-div">
            <b>Lines:</b>
            <div>
                {Object.entries(data).map(([nr, _]) => {
                    return (
                        <CheckBox
                            key={nr}
                            number={nr}
                            checked={data[nr]}
                            setChecked={setData}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default BaseLines;